export { default } from './Fab';


//////////////////
// WEBPACK FOOTER
// ../~/@material-ui/core/esm/Fab/index.js
// module id = 586
// module chunks = 121